// hooks/use-update-subscription-products.ts
import axios from 'axios';
import { Setting } from '../types/constant/PagesPropsType';
import { SubscriptionApiType } from '../types/api/SubscriptionApiType';
import { CUSTOMER_API_URL } from '../constants';
import { Products } from '../api/graphql/products/types';
import { PlanGroupsStateType } from '../types/api/PlanGroupApiType';
import { extractProductId } from '../utils/subscriptionDetail/utils';

type AddLine = {
  variantId: string;
  quantity: number;
  sellingPlanId: string;
};

type ChangeLine = {
  lineId: string;
  quantity: number;
};

type RemoveLine = {
  lineId: string;
};

export type RecProducts = Record<string, RecProduct>;

type RecProduct = {
  quantity: number;
  planGroupId: string;
  handle: string;
};

export const useUpdateSubscriptionProducts = () => {
  // selectedSetNameをproductsに変更
  const updateSubscriptionProducts = async (
    setting: Setting,
    subscription: SubscriptionApiType,
    recProducts: RecProducts,
    planGroups: PlanGroupsStateType,
    products: Products | null,
    success: (totalWeight: number) => void,
    failed: () => void,
    completion: () => void
  ) => {
    try {
      if (!products) throw new Error('商品情報が見つかりませんでした');
      console.log(recProducts);

      const addLines: AddLine[] = [];
      const changeLines: ChangeLine[] = [];
      const removeLines: RemoveLine[] = [];
      let totalWeight = 0;

      for (const line of subscription.subscriptionLines) {
        const id = extractProductId(line.productId);
        if (!id) continue;

        const recProduct = recProducts[id];
        const product = products[id];

        if (recProduct && product && recProduct.handle === product.handle) {
          changeLines.push({
            lineId: line.lineId,
            quantity: recProduct.quantity,
          });
          totalWeight = product.weight * recProduct.quantity;

          delete recProducts[id];
        } else {
          removeLines.push({
            lineId: line.lineId,
          });
        }
      }

      for (const id in recProducts) {
        const { handle, planGroupId, quantity } = recProducts[id];
        const product = products[id];
        if (!product || product.handle !== handle) continue;

        const plan = planGroups[planGroupId]?.find(
          (p) =>
            p.billingPolicyIntervalCount === subscription.billingPolicyIntervalCount &&
            p.billingPolicyInterval === subscription.billingPolicyInterval
        );
        if (!plan) continue;

        addLines.push({
          variantId: product.variantId,
          quantity: quantity,
          sellingPlanId: plan.planId,
        });
        totalWeight += product.weight * quantity;
      }

      if (addLines.length === 0) throw new Error('追加可能な商品が見つかりませんでした');

      await axios.post(
        `${CUSTOMER_API_URL}?action=updateSubscriptionV2`,
        {
          subscriptionContractId: subscription.subscriptionContractId,
          addLines,
          removeLines,
          changeLines,
        },
        { headers: { Authorization: setting.token } }
      );

      success(totalWeight);
    } catch (error) {
      console.error('商品変更エラー:', error);
      failed();
    } finally {
      completion();
    }
  };

  return { updateSubscriptionProducts };
};
